module.exports = __webpack_public_path__ + "img/fondo_newepisodios.7eea69a3.svg";